import React from 'react';
import male from '../../../../../assets/male.png';
import { format } from 'date-fns';
import { Child } from 'service/dto/children.dto';

type Props = {
  child: Child;
};

export default function DependantDetails({ child }: Props) {
  return (
    <div>
      <div className="mb-5 flex flex-row rounded border border-[#E5E5E5] bg-white">
        <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
          <div className="mr-2 flex w-40 flex-col items-center justify-center">
            <img src={male} />
          </div>
        </div>
        <div className="w-full">
          <div className="grid grid-cols-4 gap-x-16  px-4">
            <div className="col-span-1 px-8 py-6">
              <p className="text-[10px] font-normal text-[#7A7C87]">Name</p>
              <p className="mt-1 text-sm font-normal text-[#353535]">
                {`${child?.childFirstName} ${child?.childMiddleName} ${child?.childLastName}`}
              </p>
            </div>

            <div className="col-span-1 px-5 py-6">
              <p className="text-[10px] font-normal text-[#7A7C87]">
                Date of Birth
              </p>
              <p className="mt-1 text-sm font-normal text-[#353535]">
                {child?.dateOfBirth
                  ? format(new Date(child.dateOfBirth), 'dd MMMM yyyy')
                  : 'Unknown'}
              </p>
            </div>

            <div className="col-span-1 px-8 py-6">
              <p className="text-[10px] font-normal text-[#7A7C87]">Gender</p>
              <p className="mt-1 text-sm font-normal text-[#353535]">
                {child.gender}
              </p>
            </div>

            <div className="col-span-1 px-5 py-6">
              <p className="text-[10px] font-normal text-[#7A7C87]">
                Phone Number
              </p>
              <p className="mt-1 text-sm font-normal text-[#353535]">
                {child.phoneNumber}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
